const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

const fmtQty = (value) => {
  const number = Number(value || 0);
  if (!Number.isFinite(number) || number === 0) return "";
  return `${Math.round(number)}`;
};

const isQuantityFixed = (code) => ["I", "II", "III"].includes(String(code));
const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return {
    day: day.replace(/\D/g, "").padStart(2, "0"),
    month: month.replace(/\D/g, "").padStart(2, "0"),
    year: year.replace(/\D/g, ""),
  };
};

export const getPrintTemplate = ({ headerInfo, rows }) => {
  const dateParts = splitDate(headerInfo.inventoryDate || "");
  const bodyRows = (rows || [])
    .map(
      (row) => `
      <tr>
        <td class="cell center bold">${escapeHtml(row.code)}</td>
        <td class="cell">${escapeHtml(row.description)}</td>
        <td class="cell center">${isQuantityFixed(row.code) ? "x" : fmtQty(row.quantity)}</td>
        <td class="cell right">${fmtMoney(row.amount)}</td>
      </tr>`
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Bảng kiểm kê quỹ tiền mặt</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.45; }
        .right { text-align:right; line-height:1.45; }
        .title { text-align:center; margin-top:14px; font-size:20px; font-weight:700; text-transform:uppercase; }
        .subtitle { text-align:center; font-style:italic; margin-top:4px; }
        .paragraph { margin-top:8px; line-height:1.55; }
        table { width:100%; border-collapse: collapse; margin-top: 12px; }
        .cell { border: 1px solid #000; padding: 4px 6px; font-size: 14px; }
        .center { text-align: center; }
        .right { text-align: right; }
        .bold { font-weight: 700; }
        .signatures { margin-top:24px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:30%; }
        .sign-spacer { height: 18px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Địa chỉ:</b> ${escapeHtml(headerInfo.address || "")}</div>
        </div>
        <div class="right">
          <div><b>Số:</b> ${escapeHtml(headerInfo.documentNumber || "")}</div>
        </div>
      </div>

      <div class="title">BẢNG KIỂM KÊ QUỸ</div>
      <div class="subtitle">(Dùng cho VNĐ)</div>

      <div class="paragraph">
        Hôm nay, vào ${escapeHtml(headerInfo.inventoryHour || "")} giờ
        ${escapeHtml(dateParts.day || "...")} ngày
        ${escapeHtml(dateParts.month || "...")} tháng
        ${escapeHtml(dateParts.year || "....")} năm
      </div>
      <div class="paragraph">Chúng tôi gồm:</div>
      <div class="paragraph">- Ông/Bà: ${escapeHtml(headerInfo.accountantRepresentative || "")} đại diện kế toán</div>
      <div class="paragraph">- Ông/Bà: ${escapeHtml(headerInfo.cashierRepresentative || "")} đại diện thủ quỹ</div>
      <div class="paragraph">- Ông/Bà: ${escapeHtml(headerInfo.otherRepresentativeName || "")} đại diện ${escapeHtml(headerInfo.otherRepresentativeRole || "")}</div>
      <div class="paragraph">Cùng tiến hành kiểm kê quỹ tiền mặt kết quả như sau</div>

      <table>
        <thead>
          <tr>
            <th class="cell center">STT</th>
            <th class="cell center">Diễn giải</th>
            <th class="cell center">Số lượng(tờ)</th>
            <th class="cell center">Số tiền</th>
          </tr>
          <tr>
            <th class="cell center">A</th>
            <th class="cell center">B</th>
            <th class="cell center">1</th>
            <th class="cell center">2</th>
          </tr>
        </thead>
        <tbody>
          ${bodyRows}
        </tbody>
      </table>

      <div class="paragraph">- Lý do:</div>
      <div class="paragraph">+ Thừa: ${escapeHtml(headerInfo.reasonExcess || "")}</div>
      <div class="paragraph">+ Thiếu: ${escapeHtml(headerInfo.reasonShortage || "")}</div>
      <div class="paragraph">- Kết luận sau khi kiểm kê quỹ: ${escapeHtml(headerInfo.conclusion || "")}</div>

      <div class="signatures">
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Thủ quỹ</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người chịu trách nhiệm kiểm kê quỹ</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
